const calculate = {
  totalCount(groups) {
    return groups.reduce((itemsCount, group) => itemsCount + group.items.length, 0)
  },

  totalHours(groups) {
    return groups.reduce((itemsCount, group) => itemsCount + group.items.reduce((hours, item) => hours + item.duration, 0), 0)
  },

  associationIds(groups) {
    return groups.reduce((itemsByAssociationId, group) => {
      const { items: groupItems } = group

      groupItems.forEach((item) => {
        const { associationId } = item
        if (!itemsByAssociationId[associationId]) {
          itemsByAssociationId[associationId] = [item]
        } else {
          itemsByAssociationId[associationId].push(item)
        }
      })

      return itemsByAssociationId
    }, {})
  },
  associationIdCount(groups) {
    return Object.keys(calculate.associationIds(groups)).length
  },

  billingCodes(groups) {
    return groups.reduce((itemsByBillingCode, group) => {
      const { items: groupItems } = group

      groupItems.forEach((item) => {
        const { billingCode } = item
        if (!itemsByBillingCode[billingCode]) {
          itemsByBillingCode[billingCode] = [item]
        } else {
          itemsByBillingCode[billingCode].push(item)
        }
      })

      return itemsByBillingCode
    }, {})
  },
  billingCodeCount(groups) {
    return Object.keys(calculate.billingCodes(groups)).length
  },

  orders(groups) {
    return groups.reduce((itemsByOrderId, group) => {
      const { items: groupItems } = group

      groupItems.forEach((item) => {
        const { orderId } = item
        if (!itemsByOrderId[orderId]) {
          itemsByOrderId[orderId] = [item]
        } else {
          itemsByOrderId[orderId].push(item)
        }
      })

      return itemsByOrderId
    }, {})
  },
  orderCount(groups) {
    return Object.keys(calculate.orders(groups)).length
  },
}

export default calculate
